import React, { Component } from 'react';
import { Link } from "react-router-dom";
import Nav from '../containers/Nav';
import Title from '../containers/Title';
import ReactMarkdown from 'react-markdown';
import Sidebar from './Sidebar';

class Content extends Component {
    constructor(props) {
		super(props);

		this.state = { id: 0 };
        this.updateID = this.updateID.bind(this)
    }
    componentDidMount() {
        const { items } = this.props;
        const params = new URLSearchParams(window.location.search);
        const idParam = params.get("id");
        const id = (idParam && +idParam < items.size - 1) ? +idParam : items.size - 1
        this.setState({id})
    }

    updateID(id) {
        this.setState({id: id})
    }

    render() {
        const { id } = this.state
        const { items, type, selected } = this.props
        const item = items.get(id);
        const {title, subtitle, article, video, image, images, link, tag, description, url, tags, internalLink, poster, caption} = item.toObject();

        return (
            <div className="container">
                <div className="col--one">
                    <Title />
                    <Sidebar 
                        selected={id}     
                        items={items} 
                        onClick={this.updateID} 
                    />
                </div>
                <div className="col--two">
                    <Nav selected={selected || type}/>
                    {(image || images || video) && <div className="fixed-rect">
                        <div className="fixed-rect__inner">
                            {images && (
                                <div className="images">
                                    {images.map(image => <img src={image.src} style={{objectFit: image.fit, objectPosition: image.position || null }} alt=""/>)}
                                </div>
                            )}
                            {image && !internalLink && (
                                <a href={link}>
                                    <img src={image.src} style={{objectFit: image.fit, objectPosition: image.position || null }} alt=""/>
                                </a>
                            )}
                            {image && internalLink && (
                                <Link to={internalLink}>
                                    <img src={image.src} style={{objectFit: image.fit }} alt=""/>
                                </Link>
                            )}
                            {video && (
                                <iframe 
                                    width="100%" 
                                    height="100%" 
                                    title={title}
                                    src={video} 
                                    frameborder="0" 
                                    allow="autoplay; encrypted-media" 
                                    allowfullscreen>                                    
                                </iframe>
                            )}
                        </div>
                    </div>}
                    {caption && <p className="caption">{caption}</p>}
                    {tags && (
                        <ul className="tags">
                            {tags.map((tag, i) => <li key={i} className="tags__tag">#{tag}</li>)}
                        </ul>
                    )}
                    {tag && <p className="project-tag">{tag}</p>}
                    {title && <h2>{title}</h2>}
                    {subtitle && <h3>{subtitle}</h3>}
                    {article && (
                        <div>
                            <ReactMarkdown source={article}/>
                        </div>
                    )}
                    <div>
                        {description && <p>{description}</p>}
                        {url && <p>{url}</p>}
                    </div>
                    {poster && <div class="poster">
                        <a href={link}>
                            <img src={poster.src} alt=""/>
                        </a>
                    </div>}
                </div>
            </div>	
        )
    }
}

export default Content;


// WEBPACK FOOTER //
// ./src/components/Content.js